import React, { useContext, useEffect, useState } from 'react'
import { Link, Outlet, useNavigate } from 'react-router-dom';
import AuthContext from '../../store/auth-context';
import { Dialog } from 'primereact/dialog';
import { useDialogIsolation } from './useDialogIsolation';
import { DocumentTitle } from './pageTitle';

const LoadingComponent = () => {
    const authCtx = useContext(AuthContext);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if(authCtx.user){
            setIsLoading(false);
        }
        // No session (signed out, or never signed in): to sign-in, inside the app (ticket 10). v1.2 reloaded the
        // page here, which wiped the announced messages; Sign out now clears them itself (auth-context logoutUser).
        if(!localStorage.getItem("authtokens")){
            navigate("/login", { replace: true });
        }
    },[authCtx, navigate]);

    // An unverified investor sees only this dialog. RCMC-23: the app root behind it is inert, focus goes to
    // its first control. It cannot be dismissed (no close button, no Escape: v1.2 threw on Escape, onHide unset).
    // Ticket 22 (owner ruling Q37): it links to Accessibility help, after the contact lines. Those lines stay exactly as
    // production shows them (a server-only hotfix once; memory investor-portal-frontend-deploy): edit around them only.
    const pendingApproval = !isLoading && Boolean(authCtx.user) && !authCtx.user.is_verified;
    const pendingDialogIsolation = useDialogIsolation(pendingApproval, "Account Pending Approval");

    return (
        <div>
            {/* RCMC-07 (ticket 11): this screen has no route of its own, so it titles the tab itself */}
            {pendingApproval && <DocumentTitle page="Account pending approval" />}
            {isLoading || !authCtx.user ? "Loading ...." : (authCtx.user.is_verified ? <Outlet /> : <Dialog visible="true" closable={false} aria-labelledby="account-pending-title" {...pendingDialogIsolation} content={({hide}) => {
                return (
                <div style={{backgroundColor:"white",borderRadius:"10px",overflow:"hidden"}}>
                    <div id="account-pending-title" style={{padding:"10px",fontWeight:"bold",borderBottom:"1px solid #ddd"}}>Account Pending Approval</div>
                    <div style={{padding:"10px"}}>
                        Account pending approval by RCMC Operations Team. <button type="button" className='click-here' style={{color:"var(--portal-primary)",background:"none",border:"none",padding:0,font:"inherit"}} onClick={authCtx.logoutUser}>Click here</button> to return to login.
                        <br /><br />
                        For queries, please contact:
                        <br />
                        Mr. Vishal
                        <br />
                        8527695125
                        <br />
                        Email ID : sectshares@rcmcdelhi.com
                        <br /><br />
                        {/* Same tab: the public page (routes.js) shows without the investor navigation to an Investor awaiting approval.
                            tabIndex 0 works round a PrimeReact 10.6.2 bug: the Dialog's Tab trap moves focus only among the
                            elements its selector finds, and that selector counts a link only if it has attributes named
                            "clientHeight" and "clientWidth" (no link does) — without it, Tab never reached this link */}
                        <Link to="/accessibility-help" tabIndex={0} style={{color:"var(--portal-primary)"}}>Accessibility help</Link>
                    </div>
                </div>
                )}}>
            </Dialog>)}
        </div>
    );
}

export default LoadingComponent
